import { FC } from "@orgiggly/shared";
import { SnackbarProvider, useCreateSnackbar, useSnackbar } from "./hooks";
import { Alert, Button, Snackbar } from "@mui/material";

export const SnackBarWrapper: FC = ({ children }) => {
  const ctx = useCreateSnackbar();
  return (
    <SnackbarProvider value={ctx}>
      <InternalSnackBar />
      {children}
    </SnackbarProvider>
  );
};

const InternalSnackBar: FC = () => {
  const { message, closeSnackbar, isOpen } = useSnackbar();
  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={4000}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={closeSnackbar}
        severity={message?.severity}
        variant="filled"
        sx={{ width: "100%" }}
        action={
          message?.link && (
            <Button color="inherit" size="small" href={message.link.href}>
              {message.link.label}
            </Button>
          )
        }
      >
        {message?.message}
      </Alert>
    </Snackbar>
  );
};
